import React from 'react';
import { Text } from '@common-fe/common-fe';

const CoverageCodeHint = () => (
  <Text textAlign="start" size="medium">
    Coverage code will be used in the enrollment file to define the coverage level for each participant.
  </Text>
);

export default CoverageCodeHint;
